import { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'
import {
    getDialogUrl,
    WorkspaceProductListing,
} from 'shared/utils/workspaceUtils'

export interface NotesDialogProps {
    projectId: string
    getPersistedState?: (key: string) => any
    selectedProjectElementNode: ProjectElementNode | null
}

export const handleViewNotes = ({
    getPersistedState,
    projectId,
    selectedProjectElementNode,
}: NotesDialogProps) => {
    const saved = getPersistedState?.('projectNotesDialogOpened')
    const family = getPersistedState?.('selectedFamily')
    const familyId = getPersistedState?.('selectedFamilyId')
    const productType = getPersistedState?.('selectedProductType')

    // do below if windows is opened
    if (!saved) {
        window.open(
            getDialogUrl(
                {
                    family,
                    productType,
                    familyId,
                    projectId,
                    elementNode: selectedProjectElementNode,
                } as WorkspaceProductListing,
                'projectnotes'
            ),
            `ProjectNotes${projectId}`,
            'directories=no, titlebar=no, location=no, toolbar=no, menubar=no, resizable=yes,height=' +
                window.screen.height +
                ',width=' +
                window.screen.width
        )
    }
}
